document.addEventListener('DOMContentLoaded', function() {
        function getDeliveryDate() {
            var today = new Date();
            var deliveryDate = new Date(today);
            deliveryDate.setDate(today.getDate() + 2);

            // Adjust for weekends
            var day = deliveryDate.getDay();
            if (day === 6) { // Saturday, add 2 days to get Monday
                deliveryDate.setDate(deliveryDate.getDate() + 2);
            } else if (day === 0) { // Sunday, add 1 day to get Monday
                deliveryDate.setDate(deliveryDate.getDate() + 1);
            }

            // ⭐ CORRECTED LOCALE DETECTION LOGIC ⭐
            // Check for '/fr' first. If not found, default to 'en-US'.
            var locale = window.location.pathname.includes('/fr') ? 'fr-FR' : 'en-US';

            // Format the date
            var options = { weekday: 'short', month: 'short', day: 'numeric' };
            var formattedDate = deliveryDate.toLocaleDateString(locale, options);

            // Inject the formatted date
            var element = document.querySelector('.delivery_date');
            if (element) {
                element.textContent = formattedDate;
            }
        }

        getDeliveryDate();
    });